import { render, staticRenderFns } from "./CardInterruptionTimeAverage.vue?vue&type=template&id=ad800e64&scoped=true&"
import script from "./CardInterruptionTimeAverage.vue?vue&type=script&lang=ts&"
export * from "./CardInterruptionTimeAverage.vue?vue&type=script&lang=ts&"
import style0 from "./CardInterruptionTimeAverage.vue?vue&type=style&index=0&id=ad800e64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad800e64",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardSubtitle,VCol,VContainer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad800e64')) {
      api.createRecord('ad800e64', component.options)
    } else {
      api.reload('ad800e64', component.options)
    }
    module.hot.accept("./CardInterruptionTimeAverage.vue?vue&type=template&id=ad800e64&scoped=true&", function () {
      api.rerender('ad800e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/reports/dashboard/components/CardInterruptionTimeAverage.vue"
export default component.exports